import type { TaxThresholds } from '../../types/tax';

export const TAX_THRESHOLDS_2026_27: TaxThresholds = {
  under65: 99000,      // R99,000 for under 65
  age65to74: 153300,   // R153,300 for 65-74
  age75plus: 171330    // R171,330 for 75+
};
